import React, {useEffect} from "react";
import {graphql} from "gatsby";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";

const ReplicaLabel = ({image, video}) => {

  return (
    <section className='replica-label'>
      <div className='replica-label__inner'>
        <div className="replica-label__wrapper">
          {image && <Asset asset={image}/> }
        </div>
      </div>
    </section>
  )
}

export default ReplicaLabel

export const query = graphql`
fragment ReplicaLabelProps on DatoCmsReplicaLabel {
  ... on DatoCmsReplicaLabel {
    id
    image {
      ...InternalAssetProps
    }
  }
}
`